import workspaceQuery from '../../../graphql/queries/sales/AmazonConfigurationWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/AmazonConfigurationListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/AmazonConfigurationQuery.graphql';
import defaultQuery from '../../../graphql/queries/sales/AmazonConfigurationDefault.graphql';
import mutationQuery from '../../../graphql/mutations/sales/AmazonConfigurationMutation.graphql';
import fragment from '../../../graphql/fragments/sales/AmazonConfigurationFragment.graphql';
import { ALLOW_ADD, ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const AmazonConfiguration: EntityType = {
  type: 'AmazonConfiguration',
  title: 'Amazon Configurations',
  formTitle: 'Amazon Configuration',
  formUrl: '/Sales/Channel/AmazonConfig/Details/',
  workspaceUrl: '/Sales/Channel/AmazonConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
  screenReference: 'SALES_AMAZON_CONFIG',
  operations: ALLOW_ADD | ALLOW_EDIT | ALLOW_VIEW,
};

export default AmazonConfiguration;
